import React, { useEffect, useState } from 'react';
import style from './BrandItemsPage.module.scss';
import { useParams } from 'react-router-dom';
import useGetProductByBrand from 'sdk/hooks/shop/useGetProductByBrand';
import TopMenuForShopWithBack from 'modules/feed/components/Feed/TopMenuForShop/TopMenuForShopWithBack';
import useGetBrandById from 'sdk/hooks/shop/useGetBrandById';
import { useTypedSelector } from 'store/useTypedSelector';
import { useActions } from 'store/useActions';
import ShoppingCart from '../../ShoppingCart';
import ProductCard from '../../ProductsByCategory/ProductCard';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useGetProductCategories from 'sdk/hooks/shop/useGetProductCategories';
import Selector from './Selector'; 
import BtnGotoSomewhere from '../../ShoppingCart/BtnGotoSomewhere';
import useGetOrdersInTheCart from 'sdk/hooks/shop/useGetOrdersInTheCart';
import { useTranslation } from 'react-i18next';
import { normalizeProduct } from '../../ProductsByCategory/ProductsByCategory';

const mapToOptions = data => {
  const allOptions = data?.map(item => ({
    label: item?.name,
    value: item?.id,
  })) || [];
  
  return [{ label: 'All', value: 'all' }, ...allOptions];
};

const BrandItemsPage = () => {

  const {t} = useTranslation() as any
  const { id } = useParams();
  const [selectedCategory, setSelectedCategory] = useState('all');

  const { isOpenBasket } = useTypedSelector(state => state.postSlice);
  const { setIsOpenBasket } = useActions();
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;

  const { data: productsList, refetch: refetchProductsList } = useGetProductByBrand(
    id || '', 
    selectedCategory === 'all' ? undefined : selectedCategory
  );
  const { data: brand, refetch: refetchBrand } = useGetBrandById(id || '');
  const { data: categories } = useGetProductCategories();

  const options = [{ name: 'Category', placeholder: 'Category', data: categories }];


  const handleSelector = (value, name) => {
    switch (name) {
      case 'Category':
        setSelectedCategory(value);
        break;
      default:
        console.log('default');
    }
  };

  useEffect(() => {
    refetchProductsList();
    refetchBrand();
  }, [id, refetchProductsList, refetchBrand]);

    //fetch cart items to check the count of items
    const { data: cartItems, refetch: refetchCart } = useGetOrdersInTheCart(userId);

    // Aleksei - trying to fix shit pile of network requests after each cart change
    // useEffect(() => {
    //   refetchCart();
    // }, [userId]);
  
    interface CartItem {
      count: number;
      price?: number;
      product?: {
        price?: number;
      };
    }
    const itemCount = (cartItems as CartItem[] | undefined)?.reduce((total: number, item: CartItem) => total + (item.count || 0), 0) || 0;
    const displayCount = itemCount > 99 ? '99+' : itemCount;
    const cartTotal = (cartItems as CartItem[] | undefined)?.reduce((total: number, item: CartItem) => {
      const price = item.price || item.product?.price || 0;
      return total + (item.count || 0) * price;
    }, 0) || 0;
 


  return (
    <div>
      <TopMenuForShopWithBack
        icon={'goBack'}
        title={brand?.name}
        openBasket={() => setIsOpenBasket(false)}
      />
      <div>
        {options?.map(({ name, placeholder, data }) => {
          let value = null;
          // @ts-ignore
          if (name === 'Category') value = selectedCategory;
        

          return (
            <Selector
              key={name}
              name={name}
              placeholder={placeholder}
              options={mapToOptions(data)}
              value={value === 'all' 
                ? { label: t('All'), value: 'all' }
                : t(mapToOptions(data)?.find(option => option.value === value)) || { label: t('All'), value: 'all' }}
              onChange={e => handleSelector(e.value, name)}
            />
          );
        })}
      </div>
      <div className={style.products}>
        <div className={style.grid}>
          {productsList?.map(item => (
  <ProductCard key={item.id} product={normalizeProduct(item)} userId={userId} />
))}
        </div>
      </div>
      <ShoppingCart open={isOpenBasket} setOpenShoppingCartMenu={setIsOpenBasket} />
    </div>
  );
};

export default BrandItemsPage;
